<template>
    <div>
        <v-dialog
          v-model="dialog"
          persistent
          transition="slide-x-reverse-transition"
        >
            <v-card flat>
                <!-- title -->
                <v-toolbar
                  dark
                  flat
                  :color="isDeletionRequest ? 'red lighten-1' : 'primary'"
                  class="text-uppercase"
                >
                    <v-spacer/>
                    {{title}}
                    <v-spacer/>
                    <v-toolbar-items text samll>
                        <v-btn small text @click="dialog=false">
                            <v-icon>mdi-close</v-icon>
                        </v-btn>
                    </v-toolbar-items>
                </v-toolbar>
                
                <v-form @submit.prevent="submit" ref="form">
                    <!-- radio buttons -->
                    <v-radio-group
                      row
                      hide-details
                      v-model="dirType"
                      v-if="id === null"
                      @change="reset"
                    >
                        <v-radio
                            :label="$T('entities-type.doctors')"
                            :value="1"
                            class="mx-auto"
                            color="success"
                        />
                        <v-radio
                            :label="$T('entities-type.pharmacies')"
                            :value="2"
                            class="mx-auto"
                            color="success"
                        />
                        <v-radio
                            :label="$T('entities-type.centers')"
                            :value="0"
                            class="mx-auto"
                            color="success"
                        />
                    </v-radio-group>

                    <!-- card content -->
                    <v-card-text class="pb-0">
                        <v-container fluid>
                            <v-row dense>
                                <!-- name -->
                                <v-col md="6" cols="12" class="d-flex align-center">
                                    <v-text-field
                                      v-model="name"
                                      :label="$T('inputs.name')"
                                      prepend-icon="mdi-account"
                                      dense
                                      :disabled="loading || isDeletionRequest"
                                      :rules="rules.required"
                                      required
                                    ></v-text-field>

									<!-- matched entities -->
									<v-menu
										v-if="matchedEntities.length"
										offset-y
										:close-on-content-click="false"
									>
										<template v-slot:activator="{ on, attrs }">
											<v-btn
												icon
												color="red"
												class="ms-1"
												v-on="on"
												v-bind="attrs"
											>
												<v-icon>mdi-information</v-icon>
											</v-btn>
										</template>

										<!-- matched entities list -->
										<v-list dense>
											<v-subheader
												class="justify-center"
												:style="{ height: '30px' }"
											>
												{{$T('messages.matched-entities')}}
											</v-subheader>
											<v-list-item
												v-for="item in matchedEntities"
												:key="item.id"
												v-on="
													isAddingDirectly
													? {
														click: () => {
															$emit('match-selected', item.id);
															dialog = false;
														}
													}
													: null
												"
											>
												<v-list-item-icon class="me-2">
													<v-icon dense>mdi-account</v-icon>
												</v-list-item-icon>
												<v-list-item-title>
													{{item.name}}
												</v-list-item-title>
											</v-list-item>
										</v-list>
									</v-menu>
                                </v-col>

                                <!-- specialty -->
                                <v-col md="6" cols="12" v-if="dirType === 1">
                                    <v-autocomplete
                                      v-model="specialtyId"
                                      :items="specialties"
                                      :label="$T('inputs.specialty')"
                                      item-text="name"
                                      item-value="id"
                                      prepend-icon="mdi-account"
                                      dense
                                      :disabled="loading || isDeletionRequest"
                                      :rules="rules.required"
                                      required
                                    ></v-autocomplete>
                                </v-col>

                                <!-- addresses -->
                                <v-col cols="12">
                                    <div class="d-flex flex-grow-1 justify-space-between align-center">
                                        <div class="d-flex align-center">
                                            <span class="text-body-1">{{$t('Customers.addresses')}}</span>
                                        </div>

                                        <v-btn text small @click="addAddress" v-if="!isDeletionRequest">
                                            <v-icon color="grey darken-3">mdi-plus-circle-outline</v-icon>
                                        </v-btn>
                                    </div>
                                    
                                    <!-- address card -->
									<v-row
										v-for="address in addresses"
										:key="address.id"
										class="align-center"
										dense
									>
                                        <v-col cols>
                                            <!-- address card -->
                                            <v-card class="mt-4">
                                                <v-card-text>    
                                                    <v-row dense>
                                                        <!-- region -->
                                                        <v-col cols="6">
                                                            <v-autocomplete
                                                              v-model="address.data.regionId"
                                                              :items="regions"
                                                              item-text="name"
                                                              item-value="id"
                                                              :label="$T('inputs.region')"
                                                              dense
                                                              :disabled="loading || isDeletionRequest"
                                                              :rules="rules.required"
                                                              required
                                                            ></v-autocomplete>
                                                        </v-col>

                                                        <!-- workload -->
                                                        <v-col cols="6">
                                                            <v-autocomplete
                                                              v-model="address.data.workload"
                                                              :items="workloads"
                                                              item-text="name"
                                                              item-value="id"
                                                              :label="$T('inputs.workload')"
                                                              dense
                                                              :disabled="loading || isDeletionRequest"
                                                              :rules="rules.required"
                                                              required
                                                            ></v-autocomplete>
                                                        </v-col>

                                                        <!-- address -->
                                                        <v-col cols="12">
                                                            <v-text-field
                                                              v-model="address.data.address"
                                                              :label="$T('inputs.address')"
                                                              dense
                                                              :disabled="loading || isDeletionRequest"
                                                              :rules="rules.required"
                                                              required
                                                            ></v-text-field>
                                                        </v-col>
                                                    </v-row>
                                                </v-card-text>
                                            </v-card>
                                        </v-col>

                                        <!-- remove button -->
                                        <v-col cols="2" class="pa-0" v-if="!isDeletionRequest">
                                            <v-btn text small @click="removeAddress(address.id)">
                                                <v-icon color="grey darken-3">mdi-minus-circle-outline</v-icon>
                                            </v-btn>
                                        </v-col>
                                    </v-row>
                                </v-col>

                                <!-- contactInfos -->
                                <v-col cols="12">
                                    <div class="d-flex flex-grow-1 justify-space-between align-center">
                                        <div class="d-flex align-center">
                                            <span class="text-body-1">{{$t('Customers.contact-information')}}</span>
                                        </div>

                                        <v-btn text small @click="addContact" v-if="!isDeletionRequest">
                                            <v-icon color="grey darken-3">mdi-plus-circle-outline</v-icon>
                                        </v-btn>
                                    </div>
                                    
                                    <!-- contactInfos card -->
                                    <v-row
                                      v-for="contactInfo in contactInfos"
                                      :key="contactInfo.id"
                                      class="align-center"
                                    >
                                        <v-col cols>
                                            <!-- contactInfos card -->
                                            <v-card class="mt-4">
                                                <v-card-text>    
                                                    <v-row>
                                                        <!-- Contact Type -->
                                                        <v-col cols="6">
                                                            <v-autocomplete
                                                              v-model.number="contactInfo.data.contactInfoType"
                                                              :items="contactInfoTypes"
                                                              item-text="name"
                                                              item-value="id"
                                                              :label="$T('inputs.contact-type')"
                                                              dense
                                                              :disabled="loading || isDeletionRequest"
                                                              :rules="rules.requiredAsNumber"
                                                              required
                                                            ></v-autocomplete>
                                                        </v-col>

                                                        <!-- contact Label -->
                                                        <v-col cols="6">
                                                            <v-text-field
                                                              v-model="contactInfo.data.value"
                                                              :label="contactInfo.data.contactInfoType !== null ? getContactLabel(contactInfo.data.contactInfoType) : $T('inputs.contact')"
                                                              dense
                                                              :disabled="loading || isDeletionRequest"
                                                              :rules="rules.required"
                                                              required
                                                            ></v-text-field>
                                                        </v-col>
                                                    </v-row>
                                                </v-card-text>
                                            </v-card>
                                        </v-col>

                                        <!-- remove button -->
                                        <v-col cols="2" class="pa-0" v-if="!isDeletionRequest">
                                            <v-btn text small @click="removeContact(contactInfo.id)">
                                                <v-icon color="grey darken-3">mdi-minus-circle-outline</v-icon>
                                            </v-btn>
                                        </v-col>
                                    </v-row>
                                </v-col>

                                <!-- reason -->
                                <v-col md="6" cols="12">
                                    <v-text-field
                                      v-model="reason"
                                      :label="$T('inputs.reason')"
                                      dense
                                      :disabled="loading"
                                      :rules="rules.required"
                                      required
                                    ></v-text-field>
                                </v-col>
                            </v-row>
                        </v-container>
                    </v-card-text>

                    <v-spacer/>

                    <v-card-actions>
                        <v-spacer/>
                        <v-btn
                          :color="isDeletionRequest ? 'red lighten-1' : 'success'"
                          text
                          type="submit"
                          :loading="loading"
                          :disabled="loading"
                        >
                            {{$T('send')}}
                        </v-btn>
                        <v-btn color="grey darken-1" text @click="dialog = false" :disabled="loading">
                            {{$T('close')}}
                        </v-btn>
                    </v-card-actions>
                </v-form>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import rules from '@/helpers/validation rules'
import { mapState, mapGetters } from 'vuex'
export default {
	data(vm) {
		return {
			// helpers
			id: null,
			entity: null,
			dialog: false,

			title: null,

			loading: false,
			rules,

			isDeletionRequest: false,

			contactInfoTypes: [
				{ id: 0, name: vm.$t('Customers.contactInfoTypes.phone') },
				{ id: 1, name: vm.$t('Customers.contactInfoTypes.landline') },
				{ id: 2, name: vm.$t('Customers.contactInfoTypes.email') },
				{ id: 3, name: vm.$t('Customers.contactInfoTypes.facebook') },
				{ id: 4, name: vm.$t('Customers.contactInfoTypes.twitter') },
				{ id: 5, name: vm.$t('Customers.contactInfoTypes.whatsApp') },
				{ id: 6, name: vm.$t('Customers.contactInfoTypes.telegram') },
				{ id: 7, name: vm.$t('Customers.contactInfoTypes.linkedIn') },
				{ id: 8, name: vm.$t('Customers.contactInfoTypes.website') },
			],

			dirType: 1,
            
			addresses: [],
			addressesCounter: 0,
			contactInfos: [],
			contactCounter: 0,

			// search input
			isTyping: false,
			finalSearchInput: false,
			matchedEntities: [],
			isAddingDirectly: false,

			// data
			name: null,
			reason: null,
			specialtyId: null
		}
	},

	watch: {
		name(val) {
			this.isTyping = true;
			this.finalSearchInput = val;
			this.matchedEntities = [];
			setTimeout(() => {
				if (this.finalSearchInput === val) this.isTyping = false;

				if (!this.isTyping && this.name) {
					this.$store.dispatch('entities/fetchMatchedEntities', {
						name: this.name,
						regionId: this.regionId
					}).then(data => {
						this.matchedEntities = data;
					});
				}
			}, 500);
		},

		dialog(val) {
			if (!val) {
				this.isAddingDirectly = false;
			}
		}
	},

	methods: {
		reset() {
			if (this.name) {
				this.$refs.form.resetValidation();
			};

			this.id = null;
			this.addresses = [];
			this.addressesCounter = 0;
			this.contactInfos = [];
			this.contactCounter = 0;
			this.isDeletionRequest = false;

			this.name = null;
			this.reason = null;
			this.specialtyId = null;
		},

		// addresses
		addAddress() {
			if (this.dirType !== 1 && this.addressesCounter < 1) {
				this.addresses.push(
					{
						id: this.addressesCounter++,
						data: {
							regionId: null,
							workload: null,
							address: null,
						}
					}
				);
			} else if (this.dirType === 1) {
				this.addresses.push(
					{
						id: this.addressesCounter++,
						data: {
							regionId: null,
							workload: null,
							address: null,
						}
					}
				);
			} else {
				const message = this.$T('messages.one-address-for-pharmacies-and-centers');
				this.$eventBus.$emit('show-snackbar', message, 'info');
			}
		},

		removeAddress(index) {
			this.addresses.splice(index, 1);
			this.addresses.forEach(item => {
				if (item.id > index) item.id--;
			});
			this.addressesCounter--;
		},

		// contact infos
		addContact() {
			this.contactInfos.push(
				{
					id: this.contactCounter++,
					data: {
						contactInfoType: null,
						value: null,
					}
				}
			);
		},

		removeContact(index) {
			this.contactInfos.splice(index, 1);
			this.contactInfos.forEach(item => {
				if (item.id > index) item.id--;
			});
			this.contactCounter--;
		},

		getContactLabel(contactId) {
			return this.contactInfoTypes.find(contact => contact.id === contactId).name;
		},

		// dialog functions
		addCustomer(initData = null) {
			this.reset();
			this.dirType = 1;
			this.title = this.$t('Customers.creation-customer-request');
			this.dialog = true;

			if (initData) {
				this.isAddingDirectly = true;
				this.name = initData.name;
				this.addresses.push(
					{
						id: this.addressesCounter++,
						data: {
							regionId: initData.regionId,
							workload: null,
							address: null,
						}
					}
				);
			}
		},

		editCustomer(id) {
			this.reset();
			this.id = id;
			this.fillData();
			this.title = this.$t('Customers.modification-customer-request');
			this.dialog = true;
		},

		deleteCustomer(id) {
			this.reset();
			this.id = id;
			this.fillData();
			this.isDeletionRequest = true;
			this.title = this.$t('Customers.deletion-customer-request');
			this.dialog = true;
		},

		fillData() {
			this.entity = this.getEntityById(this.id);

			this.name = this.entity.name;

			this.specialtyId = this.entity.specialtyIds[0];

			this.dirType = this.entity.entityType;
            
			this.entity.entityAddresses.forEach(address => {
				this.addresses.push(
					{
						id: this.addressesCounter++,
						data: {
							regionId: address.regionId,
							workload: address.workloadId,
							address: address.address,
						}
					}
				);
			})

			this.entity.contactInfos.forEach(contactInfo => {
				this.contactInfos.push(
					{
						id: this.contactCounter++,
						data: {
							contactInfoType: contactInfo.contactInfoType,
							value: contactInfo.value,
						}
					}
				);
			})
		},

		submit() {
			if (this.$refs.form.validate()) {
				this.loading = true;

				// Deletion / modification customer request
				if (this.id) {
					this.$store.dispatch('entities/modify', {
						// requestType = 1 modification, 2 Deletion
						requestType: this.isDeletionRequest ? 2 : 1,
						entityId: this.entity.id,
						entityType: this.dirType,
						name: this.name,
						reason: this.reason,
						specialtyId: this.specialtyId,
						entityAddresses: this.addresses.map(c => c.data),
						contactInfos: this.contactInfos.map(c => c.data)
					})
						.then(() => {
							this.$eventBus.$emit('show-snackbar', this.$t('Customers.the-request-is-sent'));
							this.dialog = false;
						})
						.finally(() => {
							this.loading = false;
						})
				} else {
					// creation customer request
					this.$store.dispatch('entities/modify', {
						// requestType = 0 creation
						requestType: 0,
						entityId: null,
						entityType: this.dirType,
						name: this.name,
						reason: this.reason,
						specialtyId: this.specialtyId,
						entityAddresses: this.addresses.map(c => c.data),
						contactInfos: this.contactInfos.map(c => c.data)
					})
						.then(() => {
							this.$eventBus.$emit('show-snackbar', this.$t('Customers.the-request-is-sent'));
							this.dialog = false;
						})
						.finally(() => {
							this.loading = false;
						})
				}
			}
		}
	},

	computed: {
		...mapState({
			regions: state => state.regions.regions,
			entities: state => state.entities.entities,
			specialties: state => state.specialties.specialties,
			workloads: state => state.workloads.workloads,
		}),

		...mapGetters({
			getEntityById: 'entities/getEntityById'
		})
	}
}
</script>

<style>

</style>